namespace RioERP.Web.Enums {
    export enum ShippingPriority {
        Level1 = 1,
        Level2 = 2
    }
    Serenity.Decorators.registerEnumType(ShippingPriority, 'RioERP.Web.Enums.ShippingPriority');
}
